<template>
  <div class="relative flex min-h-screen w-full flex-col items-center justify-center p-4 bg-base dark:bg-background-dark">
    <div class="flex w-full max-w-lg flex-col overflow-hidden rounded-xl border border-line dark:border-roundBorder bg-surface shadow-lg">
      <!-- Header -->
      <!-- <header class="flex items-center justify-center whitespace-nowrap border-b border-content/10 px-6 py-4">
        <div class="flex items-center gap-3 text-content">
          <h2 class="text-lg font-bold leading-tight tracking-[-0.015em] text-content">{{ $t('login.title') }}</h2>
        </div>
      </header> -->

      <!-- Main Content -->
      <main class="flex flex-col gap-6 p-6 md:p-8">
        <div class="flex flex-col gap-2">
          <p class="text-title font-bold leading-tight tracking-[-0.033em] text-content">{{ $t('account.passwordReset.title') }}</p>
          <p class="text-title-sub font-normal leading-normal text-muted">{{ $t('account.passwordReset.description') }}</p>
        </div>

        <!-- Form -->
        <form @submit.prevent="handleSubmit" class="flex flex-col gap-4">
          <label class="flex flex-col w-full">
            <p class="pb-2 text-form-label leading-normal text-content">{{ $t('account.passwordReset.emailLabel') }}</p>
            <input
              v-model="email"
              required
              :class="[
                'form-input h-12 w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg border dark:border-roundBorder bg-base p-3 text-base font-normal leading-normal text-content placeholder:text-muted focus:outline-0 focus:ring-2 focus:ring-primary/50',
                emailError ? 'border-red-500 focus:border-red-500' : 'border-content/20 focus:border-primary'
              ]"
              :placeholder="$t('account.passwordReset.emailPlaceholder')"
            />
            <p v-if="emailError" class="mt-1 text-sm text-red-400">{{ emailError }}</p>
          </label>

          <button
            type="submit"
            :disabled="isSubmitting"
            class="flex h-12 min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg bg-primary px-5 text-grid-btn font-bold leading-normal tracking-[0.015em] text-white transition-colors hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <span class="truncate">{{ isSubmitting ? $t('account.passwordReset.sending') : $t('account.passwordReset.sendButton') }}</span>
          </button>

          <!-- Success Message -->
          <div v-if="successMessage" class="rounded-lg bg-green-500/20 border border-green-500/50 p-3 text-sm text-green-400">
            {{ successMessage }}
          </div>
        </form>
      </main>

      <!-- Footer -->
      <footer class="border-t border-solid border-content/10 bg-content/5 px-6 py-4">
        <span
          @click="goToLogin()"
          class="block text-center text-title-sub-xs leading-normal text-muted underline hover:text-content transition-colors cursor-pointer"
        >
          {{ $t('account.passwordReset.backToLogin') }}
        </span>
      </footer>
    </div>
  </div>
</template>

<script>
  import { useI18n } from 'vue-i18n';
  import axios from 'axios';
  import { AUTH_URL } from '@/config';

  export default {
    name: 'ForgotPassword',
    data() {
      return {
        email: '',
        emailError: '',
        successMessage: '',
        isSubmitting: false
      };
    },
    setup() {
      const { t } = useI18n();
      return { t };
    },
    methods: {
      goToLogin() {
        const params = new URLSearchParams(window.location.search);
        const client = params.get('client');

        if (window.Android && typeof window.Android.onForgotPasswordBackToLogin === 'function') {
          window.Android.onForgotPasswordBackToLogin();
        }
        else if (client === 'unity') {
          window.location.href = 'metadexter://login';
          return;
        }
        else {
          this.$router.push('/login');
        }
      },
      async handleSubmit() {

        this.emailError = '';
        this.successMessage = '';

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.email || !emailRegex.test(this.email)) {
          this.emailError = this.$t('account.info.emailInvalid');
          return;
        }

        this.isSubmitting = true;

        try {
          // Call password reset API
          const response = await axios.post(`${AUTH_URL}/forgotPassword`, {
            email: this.email
          });

          if (response.data.success) {
            this.successMessage = this.$t('account.passwordReset.sendCompleted');
            this.email = '';

            // Redirect to login after 3 seconds
            setTimeout(() => {
              if (window.Android && typeof window.Android.onForgotPasswordComplete === 'function') {
                window.Android.onForgotPasswordComplete();
              } else {
                this.$router.push('/login');
              }
            }, 3000);
          }

        } catch (error) {
          console.error('Password reset error:', error);
          if (error.response && error.response.status === 400) {
            this.emailError = this.$t('account.passwordReset.emailNotFound');
          } else {
            this.emailError = this.$t('account.passwordReset.error');
          }
        } finally {
          this.isSubmitting = false;
        }
      }
    }
  };
</script>

<style scoped>
  /* Override browser autofill styles */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px rgb(var(--c-surface)) inset !important;
    -webkit-text-fill-color: rgb(var(--c-content)) !important;
    caret-color: rgb(var(--c-content)) !important;
    transition: background-color 5000s ease-in-out 0s;
  }
</style>